// OR Companion Plants — стрелки ленты + добавление одновариантных товаров в корзину.
// Мульти-вариантные карточки обслуживает or-quick-variant-popup.js (data-or-qvp-open).
(function () {
    'use strict';

    if (window.orCompanionInitialized) return;
    window.orCompanionInitialized = true;

    function initSection(root) {
        var track = root.querySelector('[data-or-cp-track]');
        var prev = root.querySelector('[data-or-cp-prev]');
        var next = root.querySelector('[data-or-cp-next]');
        if (!track || !prev || !next) return;
        if (track.dataset.orCpReady) return;
        track.dataset.orCpReady = '1';

        function step() {
            var card = track.querySelector('.or-companion__card');
            if (!card) return 280;
            var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
            // Листаем по две карточки — быстрее добраться до конца ленты
            return (card.offsetWidth + gap) * 2;
        }

        function updateArrows() {
            var maxScroll = track.scrollWidth - track.clientWidth - 1;
            prev.disabled = track.scrollLeft <= 0;
            next.disabled = track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        next.addEventListener('click', function () {
            track.scrollBy({ left: step(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
    }

    function initAll(scope) {
        (scope || document).querySelectorAll('[data-or-companion]').forEach(initSection);
    }

    // Одновариантный товар — сразу в корзину, затем открываем cart-попап (как в or-quick-variant-popup.js)
    document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        var btn = e.target.closest('[data-or-cp-add]');
        if (!btn || btn.disabled) return;

        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!variantId) return;

        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        btn.classList.remove('is-error');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
            .then(function (response) {
                if (!response.ok) {
                    return response.json().catch(function () { return {}; }).then(function (errData) {
                        throw new Error(errData.description || 'Failed to add to cart');
                    });
                }
                return response.json();
            })
            .then(function () {
                btn.textContent = 'Added ✓';
                document.dispatchEvent(new CustomEvent('cart:updated'));
                setTimeout(function () {
                    if (window.openCartPopup) window.openCartPopup();
                }, 400);
                setTimeout(function () {
                    btn.disabled = false;
                    btn.textContent = originalText;
                }, 2000);
            })
            .catch(function (error) {
                console.error('Companion add to cart error:', error);
                btn.classList.add('is-error');
                btn.textContent = 'Try again';
                btn.disabled = false;
                setTimeout(function () {
                    btn.classList.remove('is-error');
                    btn.textContent = originalText;
                }, 3000);
            });
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
        initAll();
    }

    // Пересборка секции в кастомайзере
    document.addEventListener('shopify:section:load', function (e) {
        initAll(e.target);
    });
})();
